/**
 * Starts Sentry in the browser when a DSN is configured; without one nothing loads, so the
 * bundle and the network stay untouched in environments that do not report errors. Unhandled
 * errors and rejections are captured with the app's release and environment.
 *
 * @param {object} options -- DSN (empty to skip), release id and environment name.
 * @returns Whether Sentry was started.
 */
export const initSentry = async (options: {
  dsn: string;
  release: string;
  environment: string;
}): Promise<boolean> => {
  if (!options.dsn) return false;
  const sentry = await import('@sentry/browser');
  sentry.init({
    dsn: options.dsn,
    release: options.release,
    environment: options.environment,
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
  return true;
};
